import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Icon,
  LinearProgress,
  linearProgressClasses,
  CardActions,
  Button,
  Chip,
  CircularProgress
} from '@mui/material';
import React, { Component, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AhcDashboardToolbar from 'src/components/pages/ahc/ahcDashboard/AhcDashboardToolbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import ahcDashboard from '../../../../models/ahcDashboard';
import { Bar } from 'react-chartjs-2';
import CustomDoughnut from '../../../common/customDoughnut';
import CustomButton from '../../../common/customButton';
import Count from 'src/components/pages/ahc/ahcEmployees/count';
import theme from 'src/theme';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import _, { round } from 'lodash';
import moment from 'moment';
import goodalipi from 'src/plugins/goodalipi';
import ahcStatus from 'src/models/ahcStatus';

const masterDataCountItems = JSON.parse(JSON.stringify(ahcDashboard));
const pmEntityId = goodalipi.get('user') ? goodalipi.get('user').corporateType : null;
// const options = {
//   // animation: {
//   //   animateRotate: false,
//   //   animateScale: false
//   // },
//   cutout: 25,
//   radius: '85%',
//   maintainAspectRatio: false,
//   responsive: true,
//   // layout: { padding: 0 }, //default
//   plugins: {
//     legend: {
//       display: false, //default
//       // labels: {
//       //   boxWidth: 25
//       // }
//     },
//     title: {
//       display: true,
//       text: 'Male'
//     }
//   },
//   // tooltips: {
//   //   backgroundColor: theme.palette.background.paper,
//   //   bodyFontColor: theme.palette.text.secondary,
//   //   borderColor: theme.palette.divider,
//   //   borderWidth: 1,
//   //   enabled: true,
//   //   footerFontColor: theme.palette.text.secondary,
//   //   intersect: false,
//   //   mode: 'index',
//   //   titleFontColor: theme.palette.text.primary
//   // }
// };
// let baseImg;
const options = {
  animation: {
    duration: 1,
    onComplete: () => {
      // console.log(ageWiseRef);
      // baseImg =
      //   ageWiseRef && ageWiseRef.current
      //     ? ageWiseRef.current.toBase64Image()
      //     : null;
      // console.log(baseImg);
    }
  },
  indexAxis: 'y',
  cornerRadius: 20,
  layout: {
    padding: 0
  },
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    intersect: false,
    mode: 'y'
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        title: function (tooltipItem) {
          return tooltipItem[0].label.replace(',', ' ');
        },
        footer: function (tooltipItems) {
          let sum = 0;
          if (tooltipItems.length == 1) {
            return;
          }
          tooltipItems.forEach(function (tooltipItem) {
            sum += tooltipItem.parsed.x;
          });
          return 'Total: ' + sum;
        }
      }
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#aaaaaa'
      },
      stacked: true,
      grid: {
        drawBorder: false,
        borderDash: [2],
        borderDashOffset: [2]
      }
    },
    y: {
      stacked: true,
      ticks: {
        color: theme.palette.secondary.main,
        beginAtZero: true,
        min: 0
      },
      grid: {
        display: false,
        drawBorder: false
      }
    }
  }
};
const ageWiseRef = React.createRef();
// const ageData = {
//   labels: ['20+', '30+', '40+'],
//   datasets: [
//     {
//       label: 'Dataset 1',
//       data: [100, 200, 300],
//       backgroundColor: "#1778f2",
//       barPercentage: 0.5,
//       maxBarThickness: 14,
//       minBarLength: 2,
//     },
//     {
//       label: 'Dataset 2',
//       data: [300, 250, 320],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#86bcff",
//       barPercentage: 0.5,
//       // barThickness: 10,
//       maxBarThickness: 14,
//       minBarLength: 2,
//     },
//     {
//       label: 'Dataset 3',
//       data: [420, 210, 100],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#727272",
//       barPercentage: 0.5,
//       // barThickness: 10,
//       maxBarThickness: 14,
//       minBarLength: 2,
//     },
//     {
//       label: 'Dataset 4',
//       data: [280, 320, 400],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#f40009",
//       barPercentage: 0.5,
//       // barThickness: 14,
//       maxBarThickness: 14,
//       minBarLength: 2,
//     }
//   ]
// };
// const homeSampleVlabtestData = {
//   labels: [['Home Sample', 'Collection'], ['Lab Centre', 'Visit']],
//   datasets: [{
//     data: [0, 0],
//     backgroundColor: "#f40009",
//     barPercentage: 0.5,
//     maxBarThickness: 14,
//     minBarLength: 2,
//   }
//   ]
// };
// const mainData = {
//   labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//   datasets: [
//     {
//       label: 'Dataset 0',
//       data: [200, 100, 200, 140, 210, 320, 120, 400, 140, 310],
//       backgroundColor: "#b6e5b9",
//       barThickness: 9,
//       maxBarThickness: 7,
//       minBarLength: 2,
//     },
//     {
//       label: 'Dataset 1',
//       data: [100, 200, 300, 100, 200, 300, 100, 200, 100, 300],
//       backgroundColor: "#a3cbff",
//       barThickness: 9,
//       maxBarThickness: 7,
//       minBarLength: 2,
//     },
//     {
//       label: 'Dataset 2',
//       data: [300, 250, 320, 300, 250, 320, 300, 250, 300, 200],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#c7c7c7",
//       maxBarThickness: 7,
//       minBarLength: 2,
//       barThickness: 9,
//     },
//     {
//       label: 'Dataset 3',
//       data: [420, 210, 100, 420, 210, 100, 420, 210, 100, 210],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#ffcece",
//       maxBarThickness: 7,
//       minBarLength: 2,
//       barThickness: 9,
//     },
//     {
//       label: 'Dataset 4',
//       data: [280, 320, 400, 280, 320, 400, 280, 320, 200, 300],
//       // borderColor: Utils.CHART_COLORS.blue,
//       backgroundColor: "#f0b0e4",
//       maxBarThickness: 7,
//       minBarLength: 2,
//       barThickness: 9,
//     }
//   ]
// };
// const benDate = {
//   labels: ['Self', 'Mother', 'Father', 'Wife', 'Son'],
//   datasets: [
//     {
//       label: 'Dataset 1',
//       data: [1000, 200, 300, 500, 0],
//       // borderColor: Utils.CHART_COLORS.red,
//       backgroundColor: "#1778f2",
//       barPercentage: 0.5,
//       // barThickness: 10,
//       maxBarThickness: 10,
//       minBarLength: 3,
//     },
//   ]
// }
export class AhcDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusCount: [],
      totalEmployees: 0,
      totalActiveEmployess: 0,
      sponseredCount: 0,
      paidCount: 0,
      mainData: {},
      ageData: {},
      packagewisedata: {},
      homeSampleVlabtestData: {},
      benfCount: {},
      packageList: [],
      homeSampleList: {},
      satisfaction: {
        keys: [1, 2, 3, 4, 5],
        values: [0, 0, 0, 0, 0],
        totalResponses: 0,
        overAllRating: 0
      },
      legends: [
        {
          value: 'Booked',
          color: '#1778f2'
        },
        {
          value: 'Not Booked',
          color: '#86bcff'
        }
      ],
      packageActive: 0,
      loading: {
        getAllTypeCount: false,
        package: false,
        gender_age: false,
        ben: false,
        filter: false,
        rating: false
      },
      server: {
        getAllTypeCount: true,
        package: true,
        gender_age: true,
        ben: true,
        filter: true,
        rating: true
      },
      male: 0,
      female: 0,
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: [],
        payment: '',
        entityRequested: ''
      },
      filterOptions: {
        durationList: [2015, 2016, 2017, 2018, 2019, 2020, 2021],
        campusList: [],
        locationList: [],
        beneList: [],
        paymentList: [],
        entityRequested: []
      }
    };
  }

  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }));
  }

  fetchFilters(obj = {}) {
    this.setLoadingServer('filter', true, true);
    let payLoad = {};
    payLoad['service'] = 1;
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post(
        'ahc/filters',
        payLoad,
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          let entityIds = goodalipi.get('globalHRgroup')
          let entityIdRequested = entityIds ? entityIds : [];
          let city_map = [];
          _.keys(response.data.cityAndId).forEach((each) => {
            let ob = {};
            ob['key'] = each;
            ob['val'] = response.data.cityAndId[each];
            city_map.push(ob);
          });
          console.log("ahc checliads",  entityIdRequested)
          this.setState((prev) => ({
            filterOptions: {
              ...prev.filterOptions,
              entityRequested: entityIdRequested,
              locationList: city_map,
              campusList:
                response.data.result && response.data.result.PrimaryName
                  ? response.data.result.PrimaryName
                  : [],
              beneList:
                response.data.result && response.data.result.relation
                  ? response.data.result.relation
                  : [],
              paymentList:
                response.data.result && response.data.result.PaymentSource
                  ? response.data.result.PaymentSource
                  : []
            },
            totalEmployees: response.data.totalEmployees
              ? response.data.totalEmployees
              :'NA',
            totalActiveEmployess:
              response.data.totalActiveEmployees &&
                response.data.totalActiveEmployees[0].totalEmployees
                ? response.data.totalActiveEmployees[0].totalEmployees
                : 'NA'
          }));
          this.setLoadingServer('filter', false, true);
        } else {
          this.setLoadingServer('filter', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('filter', false, false);
      });
  }

  fetchgetAllTypeCount(obj = {}) {
    this.setLoadingServer('getAllTypeCount', true, true);
    let lastSelectedDays = {};
    _.forEach([...Array(12).keys()], (days) => {
      lastSelectedDays[days + 1] = {};
    });
    this.setState(
      {
        statusCount:
          goodalipi.get('isMinor') == 'isBooleantrue'
            ? _.filter(
                JSON.parse(JSON.stringify(masterDataCountItems)),
                function (o) {
                  return o.statusName == 'Total' || o.statusName == 'Attended';
                }
              )
            : JSON.parse(JSON.stringify(masterDataCountItems))
      },
      () => {
        console.log(
          JSON.parse(JSON.stringify(masterDataCountItems)),
          'masterDataCountItems'
        );
        let payLoad = {};
        payLoad['service'] = 1;
        // payLoad["year"] = this.state.filter.duration
        // payLoad["statType"] = "month"
        // payLoad["apptDateBegin"] = "2021-01-01"
        // payLoad["apptDateEnd"] = "2023-05-15"
        Object.keys(obj).map((item) => {
          payLoad[item] = obj[item];
        });
        _axios
          .post('ahc/getAllTypeCount', payLoad, {
            ignoreLoading: true,
            headers: {
              authtoken: commonService.getAuthToken(),
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            if (response.data && response.data.isSuccess) {
              const statuscount =
                goodalipi.get('isMinor') == 'isBooleantrue'
                  ? _.filter(
                      JSON.parse(JSON.stringify(masterDataCountItems)),
                      function (o) {
                        return (
                          o.statusName == 'Total' || o.statusName == 'Attended'
                        );
                      }
                    )
                  : JSON.parse(JSON.stringify(masterDataCountItems));
              console.log(statuscount);

              _.keys(response.data).forEach((key) => {
                if (key != 'isSuccess' && key != 'sponsered' && key != 'paid') {
                  statuscount.forEach((status) => {
                    status.totalCount += response.data[key][status.statusName]
                      ? parseInt(response.data[key][status.statusName])
                      : 0;
                  });
                }
              });
              _.keys(response.data).forEach((each) => {
                if (
                  each != 'isSuccess' &&
                  each != 'sponsered' &&
                  each != 'paid' &&
                  each in lastSelectedDays
                ) {
                  lastSelectedDays[each] = response.data[each];
                }
              });
              const data = {
                labels: Object.keys(lastSelectedDays).map((item) => {
                  return moment(item, 'M').format('MMM');
                }),
                datasets: []
              };
              data.datasets = (
                goodalipi.get('isMinor') == 'isBooleantrue'
                  ? _.filter(masterDataCountItems, function (o) {
                      return (
                        o.statusName == 'Total' || o.statusName == 'Attended'
                      );
                    })
                  : masterDataCountItems
              ).map((value) => {
                return {
                  label: value.status,
                  data: Object.values(lastSelectedDays).map((each) =>
                    each[value.statusName] ? each[value.statusName] : 0
                  ),
                  backgroundColor: value.darkColor,
                  barThickness: 8,
                  maxBarThickness: 6,
                  minBarLength: 2
                };
              });

              // statuscount.forEach((e) => {
              //   e.totalCount = e.totalCount ? e.totalCount : 'NA'
              // })
              this.setState({
                mainData: data,
                statusCount: statuscount,
                sponseredCount: response.data.sponsered
                  ? response.data.sponsered
                  : 0,
                paidCount: response.data.paid ? response.data.paid : 0
              });
              this.setLoadingServer('getAllTypeCount', false, true);
            } else {
              this.setLoadingServer('getAllTypeCount', false, false);
            }
          })
          .catch((error) => {
            this.setLoadingServer('getAllTypeCount', false, false);
          });
      }
    );
  }

  fetchPackageWiseCount(obj = {}) {
    this.setLoadingServer('package', true, true);
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('ahc/packageWiseCount', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          console.log(response.data);
          const labels = [],
            data = [],
            arr = [];
          _.keys(response.data.packgeWiseCount).forEach((each, index) => {
            labels.push(each);
            data.push(response.data.packgeWiseCount[each]);
            arr.push(index + 1);
          });
          const packagewisedata = {
            labels: arr,
            datasets: [
              {
                data: data,
                backgroundColor: '#1778f2',
                barPercentage: 1,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          this.setState({
            packagewisedata: packagewisedata,
            packageList: [...labels]
          });
          this.setLoadingServer('package', false, true);
          // this.fetchHomeSampleVlabtestCount();
        } else {
          this.setLoadingServer('package', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('package', false, false);
      });
  }

  fetchHomeSampleVlabtestCount(obj = {}) {
    this.setLoadingServer('package', true, true);
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('ahc/visitTypeSplit', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          let home = 0,
            lab = 0,
            homeAndLab = 0;
          _.keys(response.data.result).forEach((each) => {
            console.log(each);
            if (each == 'Appointment') {
              lab = response.data.result[each] ? response.data.result[each] : 0;
            } else if (each == 'Home_Visit') {
              home = response.data.result[each]
                ? response.data.result[each]
                : 0;
            } else if (each == 'HomeVisit_And_LabVisit') {
              homeAndLab = response.data.result[each]
                ? response.data.result[each]
                : 0;
            }
          });
          const homevsLabData = {
            labels: [
              ['Home Sample', 'Collection'],
              ['Home And', 'Lab Visit'],
              ['Lab Centre', 'Visit']
            ],
            datasets: [
              {
                data: [home, homeAndLab, lab],
                backgroundColor: '#1778f2',
                barPercentage: 0.3,
                maxBarThickness: 14,
                minBarLength: 3
              }
            ]
          };
          this.setState({
            homeSampleVlabtestData: homevsLabData
          });
          this.setLoadingServer('package', false, true);
        } else {
          this.setLoadingServer('package', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('package', false, false);
      });
  }

  // fetchBen() {
  //   this.setLoadingServer("ben", true, true);
  //   _axios.post('ahc/beneficiaryBooking', {
  //     "apptDateEnd": "2021-08-01",
  //     "apptDateBegin": "2021-01-01"
  //   }, {
  //     ignoreLoading: true,
  //     headers: {
  //       authtoken: commonService.getAuthToken(),
  //       'Content-Type': 'application/json'
  //     }
  //   }).then((response) => {
  //     if (response.data && response.data.isSuccess) {
  //       const labels = [], data = [];
  //       for (let index = 0; index < response.data.result.length; index++) {
  //         const element = response.data.result[index];
  //         labels.push(element.RelationShip);
  //         data.push(element.count)
  //       }
  //       const benfdata = {
  //         labels: labels,
  //         datasets: [
  //           {
  //             data: data,
  //             backgroundColor: "#1778f2",
  //             barPercentage: 0.5,
  //             maxBarThickness: 10,
  //             minBarLength: 3,
  //           },
  //         ]
  //       }
  //       this.setState({
  //         benfCount: benfdata
  //       });
  //       this.setLoadingServer("ben", false, true);
  //     } else {
  //       this.setLoadingServer("ben", false, false);
  //     }
  //   }).catch((error) => {
  //     this.setLoadingServer("ben", false, false);
  //   })
  // }

  // fetchAge() {
  //   this.setLoadingServer("age", true, true);
  //   _axios.post('ahc/ageWiseCount', {
  //     "year": "2021"
  //   }, {
  //     ignoreLoading: true,
  //     headers: {
  //       authtoken: commonService.getAuthToken(),
  //       'Content-Type': 'application/json'
  //     }
  //   }).then((response) => {
  //     if (response.data && response.data.isSuccess) {
  //       const labels = [], data = [];
  //       for (let index = 0; index < response.data.result.length; index++) {
  //         const element = response.data.result[index];
  //         labels.push(element.Age);
  //         data.push(element.Distribution)
  //       }
  //       const agedata = {
  //         labels: labels,
  //         datasets: [
  //           {
  //             data: data,
  //             backgroundColor: "#1778f2",
  //             barPercentage: 0.5,
  //             maxBarThickness: 10,
  //             minBarLength: 3,
  //           },
  //         ]
  //       }
  //       this.setState({
  //         ageData: agedata
  //       });
  //       this.setLoadingServer("age", false, true);
  //     } else {
  //       this.setLoadingServer("age", false, false);
  //     }
  //   }).catch((error) => {
  //     this.setLoadingServer("age", false, false);
  //   })
  // }

  fetchRating(obj = {}) {
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    this.setLoadingServer('rating', true, true);
    _axios
      .post('ahc/ratingDistribution', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          // const data = [0, 0, 0, 0, 0];
          // for (let index = 0; index < response.data.result.length; index++) {
          //   const element = response.data.result[index];
          //   data[element["OverallRating"] - 1] = round(element[""]);
          // }

          this.setState((prev) => ({
            satisfaction: {
              ...prev.satisfaction,
              // values: data,
              // totalResponses: response.data.totalCount ? response.data.totalCount : 0,
              overAllRating: response.data.avgRating
                ? response.data.avgRating
                : 0
            }
          }));
          this.setLoadingServer('rating', false, true);
        } else {
          this.setLoadingServer('rating', false, false);
        }
      })
      .catch((error) => {});
  }

  fetchGenderAge(obj = {}) {
    this.setLoadingServer('gender_age', true, true);
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('ahc/genderAndBeneficiaryCount', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          // gender assigning
          let m = 0,
            f = 0;
          _.keys(response.data.gender).forEach((each) => {
            if (['f', 'female'].indexOf(each.toLowerCase()) > -1) {
              f += response.data.gender[each];
            } else if (['m', 'male'].indexOf(each.toLowerCase()) > -1) {
              m += response.data.gender[each];
            }
          });
          // age assigning
          const labels_age = [],
            data_age = [];
          _.keys(response.data.age).forEach((each) => {
            labels_age.push(each);
            data_age.push(response.data.age[each]);
          });
          const agedata = {
            labels: labels_age,
            datasets: [
              {
                data: data_age,
                backgroundColor: '#1778f2',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          //ben assigning
          const labels_ben = [],
            data_ben = [];
          _.keys(response.data.beneficiary).forEach((each) => {
            labels_ben.push(each);
            data_ben.push(response.data.beneficiary[each]);
          });
          const benfdata = {
            labels: labels_ben,
            datasets: [
              {
                data: data_ben,
                backgroundColor: '#1778f2',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          this.setState({
            male: m,
            female: f,
            ageData: agedata,
            benfCount: benfdata
          });
          this.setLoadingServer('gender_age', false, true);
        } else {
          this.setLoadingServer('gender_age', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('gender_age', false, false);
      });
  }

  fetchHnLPackages(obj = {}) {
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('ahc/homeAndLabType', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          console.log(response.data.result);
          this.setState({
            homeSampleList: response.data.result
          });
        } else {
        }
      })
      .catch((error) => {});
  }

  onRefresh() {
    let payload = {};
    if (this.state.filter.campus.length)
      payload.provider = this.state.filter.campus;
    if (this.state.filter.location.length)
      payload.cityId = this.state.filter.location;
    if (this.state.filter.bene.length) payload.benf = this.state.filter.bene;
    if (this.state.filter.dateRange.length > 0) {
      payload.apptDateBegin = moment(this.state.filter.dateRange[0]).format(
        'YYYY-MM-DD'
      );
      payload.apptDateEnd = moment(this.state.filter.dateRange[1]).format(
        'YYYY-MM-DD'
      );
    }
    if (this.state.filter.payment) payload.payment = this.state.filter.payment;
    if (this.state.filter.entityRequested) {
      payload.globalHR = true;
      payload.entityRequested = this.state.filter.entityRequested;
    }
    this.fetchFilters(payload)
    this.fetchgetAllTypeCount(payload);
    this.fetchPackageWiseCount(payload);
    this.fetchRating(payload);
    this.fetchGenderAge(payload);
    this.fetchHomeSampleVlabtestCount(payload);
    this.fetchHnLPackages(payload);
  }

  componentDidMount() {
    this.fetchgetAllTypeCount();
    this.fetchPackageWiseCount();
    this.fetchRating();
    this.fetchGenderAge();
    this.fetchFilters();
    this.fetchHomeSampleVlabtestCount();
    this.fetchHnLPackages();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>AHC | Dashboard</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container spacing={2} alignItems="flex-start">
              {/* toolbar */}
              <Grid item xs={12}>
                {/* <Card sx={{
                  width: '100%',
                  borderRadius: 4,
                  px: 3,
                  py: 2,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}> */}
                <AhcDashboardToolbar
                  filterOptions={this.state.filterOptions}
                  filter={this.state.filter}
                  setFilters={(value) => this.setState({ filter: value })}
                  onRefresh={() => this.onRefresh()}
                />
                {/* </Card> */}
              </Grid>
              {/* left side */}
              <Grid item container lg={8} xs={12} spacing={2}>
                <Grid item xs>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      pt: 2,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <CardContent>
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        spacing={2}
                      >
                        <Grid item lg={3} sm={6} xl={3} xs={12} md={4}>
                          <Count
                            status={{
                              statusName: 'TotalEmployees',
                              status: 'Total Active Employees',
                              bgColor: '#fff',
                              totalCount: this.state.totalEmployees,
                              statusId: [32],
                              darkColor: '#40d9c4'
                            }}
                            loading={this.state.loading.filter}
                            server={this.state.server.filter}
                            refresh={() => this.fetchFilters()}
                          ></Count>
                        </Grid>
                        {/* {!pmEntityId && <Grid item lg={3} sm={6} xl={3} xs={12} md={4}>
                          <Count
                            status={{
                              statusName: 'TotalActiveEmployees',
                              status: 'Total Active Employees',
                              bgColor: '#fff',
                              totalCount: this.state.totalActiveEmployess,
                              statusId: [32],
                              darkColor: '#b6e5b9'
                            }}
                            loading={this.state.loading.filter}
                            server={this.state.server.filter}
                            refresh={() => this.fetchFilters()}
                          ></Count>
                        </Grid>} */}
                        {this.state.statusCount.map((each, idx) => (
                          <Grid
                            item
                            lg={3}
                            sm={6}
                            xl={3}
                            xs={12}
                            md={4}
                            key={idx}
                          >
                            <Count
                              status={each}
                              loading={this.state.loading.getAllTypeCount}
                              server={this.state.server.getAllTypeCount}
                            />
                          </Grid>
                        ))}
                        {goodalipi.get('isMinor') == 'isBooleantrue' && (
                          <>
                            <Grid item lg={3} sm={6} xl={3} xs={12} md={4}>
                              <Count
                                status={{
                                  statusName: 'SponseredAvailed',
                                  status: 'Sponsored',
                                  bgColor: '#fff',
                                  totalCount: this.state.sponseredCount,
                                  statusId: [24, 30, 31, 40],
                                  darkColor: '#ffe1b4'
                                }}
                                loading={this.state.loading.getAllTypeCount}
                                server={this.state.server.getAllTypeCount}
                              />
                            </Grid>
                            <Grid item lg={4} sm={6} xl={4} xs={12} md={4}>
                              <Count
                                status={{
                                  statusName: 'PaidAvailed',
                                  status: 'Paid',
                                  bgColor: '#fff',
                                  totalCount: this.state.paidCount,
                                  statusId: [22],
                                  darkColor: '#ffcece'
                                }}
                                loading={this.state.loading.getAllTypeCount}
                                server={this.state.server.getAllTypeCount}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                      <PerfectScrollbar>
                        <Box
                          sx={{
                            height: '300px',
                            width: `calc(${
                              this.state.mainData.labels
                              ? this.state.mainData['labels'].length
                              : 10
                              }*70px)`,
                            mt: 5
                          }}
                          className={
                            this.state.loading.getAllTypeCount
                              ? 'display-center'
                              : ''
                          }
                        >
                          {this.state.loading.getAllTypeCount ? (
                            <CircularProgress size={30} />
                          ) : (
                            <VerticalBarGraph data={this.state.mainData} />
                          )}
                        </Box>
                      </PerfectScrollbar>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Card
                    sx={{
                      width:
                        goodalipi.get('isMinor') != 'isBooleantrue'
                          ? '100%'
                          : '152%',
                      minHeight: '245px',
                      borderRadius: 4,
                      p: 1,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <CardHeader
                      title="Packages Booked"
                      sx={{ pb: 1 }}
                      action={
                        <Grid container>
                          <CustomButton
                            onClick={() => this.setState({ packageActive: 0 })}
                            loading={this.state.loading.package}
                            fontSize={11}
                            active={this.state.packageActive == 0}
                            title="Package Types"
                            sx={{ mr: 1 }}
                          />
                          <CustomButton
                            onClick={() => this.setState({ packageActive: 1 })}
                            loading={this.state.loading.package}
                            fontSize={11}
                            active={this.state.packageActive == 1}
                            title="Home Sample Collection vs Lab Visit"
                            shadow="true"
                          />
                        </Grid>
                      }
                    />
                    {this.state.loading.package ? (
                      <Box
                        className={
                          this.state.loading.package
                            ? 'display-center m-t-20'
                            : ''
                        }
                      >
                        <CircularProgress size={30} />
                      </Box>
                    ) : (
                      <Grid container sx={{ px: 2, my: 2 }}>
                        <Grid item xs={12} sm={8} sx={{ pr: 1 }}>
                          <PerfectScrollbar>
                            {this.state.packageActive == 0 ? (
                              <Box
                                sx={{
                                  minWidth: '350px',
                                  // height: '200px',
                                  maxHeight: '200px',
                                  width: `calc(${
                                    this.state.packagewisedata.labels
                                    ? this.state.packagewisedata['labels']
                                      .length
                                    : 10
                                    }*30px)`
                                }}
                              >
                                <VerticalBarGraph
                                  data={this.state.packagewisedata}
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  width: '100%'
                                  // minWidth: '350px',
                                  // width: `calc(${benDate["labels"].length}*90px)`,
                                }}
                              >
                                <Bar
                                  options={options}
                                  data={this.state.homeSampleVlabtestData}
                                ></Bar>
                              </Box>
                            )}
                          </PerfectScrollbar>
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          sm={4}
                          sx={{
                            borderRadius: 2,
                            border: '1px solid #e8e8e8',
                            py: 1
                          }}
                          direction="column"
                        >
                          <PerfectScrollbar>
                            <Box sx={{ maxHeight: 140, height: 140, mx: 1 }}>
                              {this.state.packageActive == 0 ? (
                                <div>
                                  <Typography variant="h6">
                                    {' '}
                                    Packages{' '}
                                  </Typography>
                                  <Chip
                                    sx={{
                                      bgcolor: '#eaf2ff',
                                      fontSize: 10,
                                      color: 'red',
                                      height: 15,
                                      width: 'fit-content',
                                      my: 1,
                                      borderRadius: 1,
                                      px: 0
                                    }}
                                    label={
                                      (this.state.packagewisedata.labels
                                        ? this.state.packagewisedata.labels
                                            .length
                                        : 0) + ' Packages'
                                    }
                                  />
                                  <br></br>
                                  <ol start="1">
                                    {this.state.packageList.length &&
                                      this.state.packageList.map((each) => (
                                        <li>
                                          <Typography variant="caption">
                                            {' '}
                                            {each}
                                          </Typography>
                                        </li>
                                      ))}
                                  </ol>
                                </div>
                              ) : (
                                <div>
                                  <Typography variant="h6">
                                    {' '}
                                    Home Sample Collection{' '}
                                  </Typography>
                                  <Chip
                                    sx={{
                                      bgcolor: '#eaf2ff',
                                      fontSize: 10,
                                      color: 'red',
                                      height: 15,
                                      width: 'fit-content',
                                      my: 1,
                                      borderRadius: 1,
                                      px: 0
                                    }}
                                    label={
                                      (this.state.homeSampleList.home_visit
                                        ? this.state.homeSampleList.home_visit
                                            .length
                                        : 0) + ' Packages'
                                    }
                                  />
                                  <br></br>
                                  <ol start="1">
                                    {this.state.homeSampleList.home_visit &&
                                      this.state.homeSampleList.home_visit.map(
                                        (each) => (
                                          <li>
                                            <Typography variant="caption">
                                              {' '}
                                              {each}
                                            </Typography>
                                          </li>
                                        )
                                      )}
                                  </ol>
                                  <br></br>
                                  <Typography variant="h6">
                                    {' '}
                                    Home And Lab Visit{' '}
                                  </Typography>
                                  <Chip
                                    sx={{
                                      bgcolor: '#eaf2ff',
                                      fontSize: 10,
                                      color: 'red',
                                      height: 15,
                                      width: 'fit-content',
                                      my: 1,
                                      borderRadius: 1,
                                      px: 0
                                    }}
                                    label={
                                      (this.state.homeSampleList.homeAndLabVisit
                                        ? this.state.homeSampleList
                                            .homeAndLabVisit.length
                                        : 0) + ' Packages'
                                    }
                                  />
                                  <br></br>
                                  <ol start="1">
                                    {this.state.homeSampleList
                                      .homeAndLabVisit &&
                                      this.state.homeSampleList.homeAndLabVisit.map(
                                        (each) => (
                                          <li>
                                            <Typography variant="caption">
                                              {' '}
                                              {each}
                                            </Typography>
                                          </li>
                                        )
                                      )}
                                  </ol>
                                  <br></br>
                                  <Typography variant="h6">
                                    {' '}
                                    Lab Center Visit{' '}
                                  </Typography>
                                  <Chip
                                    sx={{
                                      bgcolor: '#eaf2ff',
                                      fontSize: 10,
                                      color: 'red',
                                      height: 15,
                                      width: 'fit-content',
                                      my: 1,
                                      borderRadius: 1,
                                      px: 0
                                    }}
                                    label={
                                      (this.state.homeSampleList.lab_visit
                                        ? this.state.homeSampleList.lab_visit
                                            .length
                                        : 0) + ' Packages'
                                    }
                                  />
                                  <br></br>
                                  <ol start="1">
                                    {this.state.homeSampleList.lab_visit &&
                                      this.state.homeSampleList.lab_visit.map(
                                        (each) => (
                                          <li>
                                            <Typography variant="caption">
                                              {' '}
                                              {each}
                                            </Typography>
                                          </li>
                                        )
                                      )}
                                  </ol>
                                </div>
                              )}
                            </Box>
                          </PerfectScrollbar>
                        </Grid>
                      </Grid>
                    )}
                  </Card>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {goodalipi.get('isMinor') != 'isBooleantrue' ? (
                    <Card
                      sx={{
                        width: '100%',
                        // height: '245px',
                        borderRadius: 4,
                        p: 1,
                        boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                      }}
                    >
                      <CardHeader title="Overall Rating" sx={{ pb: 1 }} />
                      <Box sx={{ px: 2 }}>
                        {/* <Typography variant="h5">Overall Rating</Typography><br /> */}
                        {this.state.loading.rating ? (
                          <CircularProgress size={30} />
                        ) : (
                          <Typography variant="h2">
                            {this.state.satisfaction.overAllRating}/5
                          </Typography>
                        )}
                        {/* <Grid container direction="row" alignItems="center">
                        <Icon sx={{ fontSize: 15 }}>
                          <img className="fit-to-parent" src="/static/images/employees.svg"></img>
                        </Icon>
                        <Typography variant="caption" sx={{ color: '#868898', ml: 1 }}>{this.state.satisfaction.totalResponses} Responses</Typography>
                      </Grid>
                      {this.state.satisfaction.keys.map((val, idx) =>
                        <Grid key={idx} container direction="row" alignItems="center" sx={{ my: 1 }}>
                          <Typography variant="h6">{val}</Typography>
                          <Box sx={{ flexGrow: 1, mx: 1 }}>
                            <LinearProgress sx={{
                              height: 12,
                              [`& .${linearProgressClasses.bar}`]: {
                                backgroundColor: "#f7b900"
                              },
                              [`&.${linearProgressClasses.colorPrimary}`]: {
                                backgroundColor: "#f7f7f7"
                              }
                            }} variant="determinate" value={this.state.satisfaction.values[idx]} />
                          </Box>
                          <Typography variant="h6">{this.state.satisfaction.values[idx]}%</Typography>
                        </Grid>
                      )} */}
                      </Box>
                    </Card>
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
              {/* right side */}
              <Grid item container lg={4} xs={12}>
                {/* top card */}
                <Grid item xs={12}>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      p: 1,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <Card elevation={0}>
                      <CardHeader
                        title="Gender-Wise (Attended)"
                        sx={{ pb: 1 }}
                      />
                      <Grid item container xs={12} direction="row">
                        <Grid item xs={12} sm={6}>
                          {this.state.loading.gender_age ? (
                            <Box
                              sx={{
                                height: 155
                              }}
                              className={
                                this.state.loading.gender_age
                                  ? 'display-center'
                                  : ''
                              }
                            >
                              <CircularProgress size={30} />
                            </Box>
                          ) : (
                            <CustomDoughnut
                              count={this.state.male}
                              title="Male"
                            />
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {this.state.loading.gender_age ? (
                            <Box
                              sx={{
                                height: 155
                              }}
                              className={
                                this.state.loading.gender_age
                                  ? 'display-center'
                                  : ''
                              }
                            >
                              <CircularProgress size={30} />
                            </Box>
                          ) : (
                            <CustomDoughnut
                              count={this.state.female}
                              backgroundColor={['#ff92a6']}
                              title="Female"
                            />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: 10, textAlign: 'center', mt: 1 }}
                          >
                            {' '}
                            Total Eligible Male: {this.state.male}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: 10, textAlign: 'center', mt: 1 }}
                          >
                            {' '}
                            Total Eligible Female: {this.state.female}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                    <Divider sx={{ mt: 2 }} />
                    <Card elevation={0}>
                      <CardHeader title="Age-Wise (Attended)" />
                      <Grid item xs={12} sx={{ px: 3, mb: 3 }}>
                        <Box
                          sx={{
                            height: 180
                          }}
                          className={
                            this.state.loading.gender_age
                              ? 'display-center'
                              : ''
                          }
                        >
                          {this.state.loading.gender_age ? (
                            <CircularProgress size={30} />
                          ) : (
                            <Bar
                              options={options}
                              data={this.state.ageData}
                              ref={ageWiseRef}
                            ></Bar>
                          )}
                        </Box>
                      </Grid>
                    </Card>
                    <Grid sx={{ px: 2, mb: 2 }} direction="row" container>
                      {this.state.legends.map((val, idx) => (
                        <Grid
                          key={idx}
                          container
                          item
                          xs={6}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Box
                            sx={{
                              height: 14,
                              width: 14,
                              borderRadius: 1,
                              mr: 1,
                              bgcolor: val['color'],
                              cursor: 'pointer'
                            }}
                          />
                          <Typography variant="caption">{val.value}</Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>
                </Grid>
                {/* bottom card */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      p: 1,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <CardHeader title="Beneficiary Booking (Attended)" />
                    <CardContent>
                      <PerfectScrollbar>
                        <Box
                          sx={{
                            height: '200px',
                            width: `calc(${
                              this.state.benfCount.labels
                              ? this.state.benfCount['labels'].length
                              : 5
                              }*70px)`
                          }}
                          className={
                            this.state.loading.gender_age
                              ? 'display-center'
                              : ''
                          }
                        >
                          {this.state.loading.gender_age ? (
                            <CircularProgress size={30} />
                          ) : (
                            <VerticalBarGraph data={this.state.benfCount} />
                          )}
                        </Box>
                      </PerfectScrollbar>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </>
    );
  }
}

export default AhcDashboard;
